











import { Component, Vue }            from 'vue-property-decorator';
import { Getter, State }             from 'vuex-class';
import { Breakpoint, getBreakpoint } from '@/shared/UI/Breakpoint';
import { Styled }                    from '@/shared/UI/Styled';
import { ProfileState }              from '@/store/profile/types';

const namespace: string = 'profile';

@Component
export default class Title extends Vue implements Styled {
  @State('profile')
  private profile: ProfileState;

  @Getter('fullName', { namespace })
  private fullName: string;

  get description() {
    return this.profile.user && this.profile.user.description;
  }

  get styled() {
    return classes(getBreakpoint(this));
  }
}

const classes = (bp: Breakpoint) => ({
  titleContainer: {
    'ib-title': true,
    'ib-title-mobile-port': bp.xsOnly
  },
  titleText: {
    'display-1': bp.smAndDown,
    'display-3': bp.mdAndUp,
    'headline': bp.xsOnly
  },
  subtitle: {
    'caption': bp.smAndDown,
    'subheading': bp.mdAndUp
  }
});
